// src/components/ProtectedLayout.js
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./Context/AuthContext";
import { QueryClientProvider } from '@tanstack/react-query';
import Topbar from "./Components/Topbar";
import Dashboard from "./Components/Dashboard";
import { queryClient } from './Api/queryClient';
import { AssetProvider } from "./Context/MasterContext/AssetContext";
import { ServiceProvider } from "./Context/MasterContext/ServiceContext";
import { MasterDataProvider } from "./Context/masterDataContext";
import { CRMDataProvider } from "./Context/CRMContext";
import './theme/theme.css';
const ProtectedLayout = () => {
  const { isAuthenticated, loading } = useAuth();

  // ⏳ Wait until auth is resolved
  if (loading) return null;

  // 🔒 Not logged in → go to login page
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // ✅ Logged in → allow access
  return (
    <QueryClientProvider client={queryClient}>
    <MasterDataProvider>
      <AssetProvider>
        <ServiceProvider>
          <CRMDataProvider>
            <Topbar />

            <Dashboard />
          <div className="main" id="main">
              <Outlet />
              </div>
       
          </CRMDataProvider>
        </ServiceProvider>
      </AssetProvider>
    </MasterDataProvider>
    </QueryClientProvider>
  );
};

export default ProtectedLayout;

// // src/components/ProtectedLayout.js
// import Topbar from './Components/Topbar';
// import Dashboard from './Components/Dashboard';
// import { Outlet } from 'react-router-dom';
// import { AssetProvider } from "./Context/MasterContext/AssetContext";
// import { ServiceProvider } from './Context/MasterContext/ServiceContext';
// import { MasterDataProvider } from './Context/masterDataContext';
// import { CRMDataProvider } from './Context/CRMContext';

// const ProtectedLayout = () => {
//   return (
//     <>
//       <MasterDataProvider>
//         <AssetProvider>
//           <ServiceProvider>
//             <CRMDataProvider>
//               <Topbar />
//               <Dashboard />
//               <div className="main" id="main">
//                 <Outlet />
//               </div>
//             </CRMDataProvider>
//           </ServiceProvider>
//         </AssetProvider>
//       </MasterDataProvider>

//     </>
//   );
// };

// export default ProtectedLayout;
